import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import Highcharts, { Options } from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import exportingData from 'highcharts/modules/export-data'
import HighchartsNoData from 'highcharts/modules/no-data-to-display'
import { Chart } from 'highcharts-vue'
import { highchartDefaultOptions, HighchartsState, initialHighchartState } from '@/components/common/highchart/highchart.model'
import { uniqueId, merge } from 'lodash'

// Exporting options context button
exportingInit(Highcharts)
exportingData(Highcharts)
HighchartsNoData(Highcharts)
@Component({
    components: {
        chart: Chart
    }
}
)
export default class Highchart extends Vue {
    @Ref() readonly highchartRef!: any
    state !: HighchartsState
    @Prop() readonly chartOptions!: Options
    @Watch('chartOptions')
    onChartOptionsChanged(value: Options): void {
        this._extendDefaultOptions(value)
    }

    constructor() {
        super()
        this.state = initialHighchartState()
    }

    get optionsChart(): Options {
        return this.state.chartOptions
    }

    mounted() {
        this._extendDefaultOptions(this.chartOptions)
    }

    private _extendDefaultOptions(chartOptions: Options) {
        this.state.chartOptions = merge(highchartDefaultOptions(), chartOptions)
        this._refreshUID()
    }

    private _refreshUID(): void {
        this.state.chartUID = uniqueId()
    }
}
